import ColorfulSlide from './colorful-slide';
export default ColorfulSlide;
